import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 35,
    textAlign: 'center'
  },
  image: {
    marginTop: 40,
    display: 'inline-block',
    maxWidth: '100%',
    width: 350
  }
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <Typography color='primary' variant="h1">
              چنین صفحه ای وجود ندارد
            </Typography>
            
            <img
              alt="Under development"
              className={classes.image}
              src="/images/bg-404.svg"
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
